module.exports = __webpack_public_path__ + "img/businessModel3.713ac798.png";